import { CustomTooltip, Input } from '@fountain/fountain-ui-components';
import { FormControlLabel, Grid, Switch, Typography } from '@material-ui/core';
import {
  WorkflowSchedulingStage,
  WorkflowStageDetail,
} from 'api-clients/monolith';
import cx from 'classnames';
import produce from 'immer';
import React, { useContext, VFC } from 'react';
import { useIntl } from 'react-intl';

import {
  StageSettingCard,
  StageSettingCardProps,
} from 'containers/WorkflowEditor/components/StageSettingCard';
import { StageContext } from 'containers/WorkflowEditor/contexts/stageContext';
import InfoGrey from 'images/info-grey.svg';

import { messages } from './messages';
import { useStyles } from './styles';

export interface ReviewStageProps {
  stage: WorkflowSchedulingStage;
  setStage: React.Dispatch<React.SetStateAction<WorkflowStageDetail>>;
}

export const ReviewStage: VFC<{ stage: WorkflowStageDetail }> = ({ stage }) => {
  const intl = useIntl();
  const { setStage } = useContext(StageContext);
  const styles = useStyles();
  const showInDashboard = stage.show_in_dashboard;

  const stageSettingCardProps: StageSettingCardProps = {
    title: intl.formatMessage(messages.reviewStage),
    variant: 'default',
  };

  const onToggleReviewStage = () => {
    setStage(
      produce(stage, draftStage => {
        draftStage.show_in_dashboard = !draftStage.show_in_dashboard;
        // if setting false, set task_instructions to empty
        if (!draftStage.show_in_dashboard) {
          draftStage.task_instructions = '';
        }
      }),
    );
  };

  const onChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStage(
      produce(stage, draftStage => {
        draftStage.task_instructions = e.target.value;
      }),
    );
  };

  return (
    <StageSettingCard {...stageSettingCardProps}>
      <Grid className={styles.padding}>
        <FormControlLabel
          control={
            <Switch
              data-testid="review-stage-enabled"
              checked={showInDashboard}
              onChange={onToggleReviewStage}
            />
          }
          label={
            <Typography variant="body2" component="div">
              <Grid className={cx(styles.text, styles.padding)}>
                {intl.formatMessage(messages.markReviewStage)}
                <CustomTooltip
                  className={styles.infoTooltip}
                  title={intl.formatMessage(messages.tooltip)}
                  dense
                >
                  <img
                    src={InfoGrey}
                    alt={intl.formatMessage(messages.tooltip)}
                  />
                </CustomTooltip>
              </Grid>
            </Typography>
          }
        />
        {showInDashboard && (
          <div className={styles.wrapTaskInfo}>
            <Typography variant="h4" className={styles.taskTitle}>
              {intl.formatMessage(messages.taskInstructionsTitle)}
            </Typography>
            <Input
              value={stage.task_instructions ?? ''}
              onChange={onChangeText}
              data-testid="instruction-tasks-input"
              placeholder={intl.formatMessage(
                messages.taskInstructionsPlaceholder,
              )}
            />
          </div>
        )}
      </Grid>
    </StageSettingCard>
  );
};
